import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import EditableFieldDialog from './editableFieldDialog'
import { formatDateString } from './formatters/dateFormatter'
import { renderRoom } from './formatters/roomFormatter'
import SalesForceFieldLink from './salesForceFieldLink'

@autobind
export default class VisitDetailsDialog extends Component {
  static propTypes = {
    show: PropTypes.bool,
    edits: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    visit: PropTypes.object,
    guest: PropTypes.object,
    room: PropTypes.object
  }

  static defaultProps = {
    visit: {},
    guest: {}
  }

  render() {
    let { visit, guest, room, edits } = this.props
    let fields = [
      {
        label: 'Name',
        value: <SalesForceFieldLink text={guest.name} id={guest.id} />
      },
      {
        label: 'Check In Date',
        value: visit.checkInDate,
        valueRenderer: formatDateString
      },
      {
        label: 'Check Out Date',
        value: visit.checkOutDate,
        valueRenderer: formatDateString
      },
      {
        label: 'Room',
        value: renderRoom(room),
        name: room.name,
        isClean: room.isClean
      },
      {
        label: 'Checked In',
        value: visit.checkedIn,
        type: 'checkbox',
        fieldName: 'checkedIn',
        displayValue: visit.checkedIn && !visit.checkedOut,
        // Disable editing if they're checked out because I'm not sure what to do in that case
        editable: !visit.checkedOut
      }
    ]
    if (edits.checkedIn === false) {
      fields.push({
        label: 'Mark room as dirty',
        value: true,
        type: 'checkbox',
        fieldName: 'markRoomDirty'
      })
    }
    return (
      <EditableFieldDialog
        {...this.props}
        title={<SalesForceFieldLink text='Visit Details' id={visit.id} />}
        fields={fields}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/visitDetailsDialog.js